// SessionGql.js
import {gql} from '@apollo/client';

const SESSION_DATA = gql`
fragment WholeSessionData on SessionData {
    user {
      userId
      password
      userName
      custId
      custName
      industryId
      classId
      classNo
      email
      admin
      etrace
      loginTime
      logoutTime
      secondAuthMsg
      viewLevel
      initXcoord
      initYcoord
      initLat
      initLon
      smsUseFlag
      poiByGroupCd
      option
      needSecondAuth
      msg
    }
    userAs {
      userId
      password
      userName
      custId
      custName
      industryId
      classId
      classNo
      email
      admin
      etrace
      loginTime
      logoutTime
      secondAuthMsg
      viewLevel
      initXcoord
      initYcoord
      initLat
      initLon
      smsUseFlag
      poiByGroupCd
      option
      needSecondAuth
      msg
    }
}
`;

export const LOG_IN = gql`
${SESSION_DATA}
query logIn($userId:String!, $password:String!) {
  login(userId:$userId, password:$password) {
    ...WholeSessionData
  }
}
`;

export const LOG_IN_AS = gql`
${SESSION_DATA}
query LoginAs($userId:String!) {
    loginAs(userId:$userId) {
        ...WholeSessionData
    }
}
`;

export const LOG_OUT = gql`
${SESSION_DATA}
query logOut {
  logout {
    ...WholeSessionData
  }
}
`;

export const GET_SESSION_DATA = gql`
${SESSION_DATA}
query {
  getSessionData {
    ...WholeSessionData
  }
}
`;

/*

type MapShowJob {
    userId: String!
    show: String
    vehId: Int
    vehPlates: String
    custId: String
    mapLevel: Int
    showDataBox: Boolean
    expireTime: Int
    from: String
    till: String
}

type MapLinkSessionData {
    msg: String!
    mapShowJob: MapShowJob
	sessionData: SessionData
}
mapLinkLogin(custId: String!, encodedData: String!, aes: Boolean!, mobile: Boolean!): MapLinkSessionData

*/

// 고객이 링크 parameter로 접근하면, 암호화된 데이터를 서버에 보내 
// 로그인이 되게하고, 암호화된 데이터 안에 들어있는 정보를 받아서 다음 액션에 사용할 수 있다.
export const MAP_LINK_LOGIN = gql`
${SESSION_DATA}
query mapLinkLogin($custId: String!, $encodedData: String!, $aes: Boolean!, $mobile: Boolean!) {
    mapLinkLogin(custId: $custId, encodedData: $encodedData, aes: $aes, mobile: $mobile) {
        msg
        mapShowJob {
            userId
            show
            vehId
            vehPlates
            custId
            mapLevel
            showDataBox
            expireTime
            from
            till
        }
        sessionData {
            ...WholeSessionData
        }
    }
}
`;



export const GET_CODE_N_MENU = gql`
query {
    codeTree {
        cdType
        cdTypeName
        codes {
            cd
            cdOld
            cdName
            cdType
            cdOrder
            text1
            text2
            text3
            text4
            intVal1
            intVal2
            intVal3
            cdDesc
        }
    }
    menuToUserTree {
        kindId
        kindName
        kindOrder
        kindDesc
        menus {
            menuId
            menuName
            userId
            myName
            bookMark
            menuOrder
            regTime
        }
    }
    userTcolConf21List {
        userId
        viewName
        colsCsv
        regDate
    }
}
`;

// checkSecondAuth(code:String!): SessionData
export const CHECK_SECOND_AUTH = gql`
${SESSION_DATA}
query checkSecondAuth($code:String!) {
    checkSecondAuth(code:$code) {
        ...WholeSessionData
    }
}
`;

